import { NgxPermissionsService } from 'ngx-permissions'
import {
  UploadBusinessImageRequest,
  DeleteBusinessImageRequest,
} from '../../businesses.actions'
import { FetchImageTypesRequest } from '@shared/shared.actions'
import {
  getUpdateBusinessState,
  getImageTypesState,
  getCreateBusinessState,
} from '../../businesses.selectors'
import { Map, List, fromJS } from 'immutable'
import { ActivatedRoute, Router } from '@angular/router'
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core'
import { Store, select } from '@ngrx/store'
import { Subscription } from 'rxjs'
import jsonToFormData from 'json-form-data'
import { getSettingsState } from '@containers/settings/settings.selectors'
import FormTrait from 'src/app/traits/form.trait'

@Component({
  selector: 'gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
})
export class GalleryComponent extends FormTrait implements OnInit, OnDestroy {
  public businessId: number
  private state$: Subscription
  private imageTypes$: Subscription
  public imageTypes: List<Map<string, any>>
  public isLoading: boolean
  public shouldReload: boolean
  public images: Map<string, any>
  public propertyImages: Map<string, any>
  public isReadonly: boolean
  public nextStatus: string
  public hasReadonlyPermission: boolean = false
  private settings$: Subscription
  public imageBasePath: string
  public hasProperty: boolean

  constructor(
    public permissionsService: NgxPermissionsService,
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super()
  }

  ngOnInit() {
    this.businessId = parseInt(this.route.snapshot.paramMap.get('id'))
    this.hasReadonlyPermission =
      this.permissionsService.getPermissions()['READONLY'] !== undefined
    const getState = this.businessId
      ? getUpdateBusinessState
      : getCreateBusinessState

    this.state$ = this.store.pipe(select(getState)).subscribe((state) => {
      this.state = state
      this.hasProperty = !!state.getIn(['data', 'propertyConnection'])
      const images = state.getIn(['data', 'images'])
      const propertyImages = this.hasProperty
        ? state.getIn(['data', 'propertyConnection', 'images'])
        : fromJS([])
      const imagesMap =
        images &&
        images.toKeyedSeq().mapEntries(function (kv: Map<string, any>) {
          return [kv[1].getIn(['imageType', 'name']), kv[1]]
        })
      const propertyImagesMap =
        propertyImages &&
        propertyImages
          .filter((image: Map<string, any>) =>
            image.getIn(['imageType', 'forBusiness']),
          )
          .toKeyedSeq()
          .mapEntries(function (kv: Map<string, any>) {
            return [kv[1].getIn(['imageType', 'name']), kv[1]]
          })
      this.isLoading = state.get('isLoading')
      this.shouldReload = state.get('shouldReload')
      this.images = imagesMap
      this.propertyImages = propertyImagesMap

      // if (this.businessId) {
      //   this.isReadonly =
      //     (this.state.getIn(['data', 'status', 'name']) !== 'DATA_ENTRY' &&
      //       this.state.getIn(['data', 'status', 'name']) !== 'OBJECTION') ||
      //     this.hasReadonlyPermission
      // }
    })

    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.imageBasePath = state.getIn([
          'data',
          'path',
          'PATH_IMAGE_BASE_URL',
        ])
      })

    this.imageTypes$ = this.store
      .pipe(select(getImageTypesState))
      .subscribe((state) => {
        this.imageTypes = state.get('data')
      })

    this.store.dispatch<any>(new FetchImageTypesRequest('business'))
  }

  public upload({ event, imageTypeId }) {
    const file: File = event.target.files[0]
    const payload = jsonToFormData({ file, imageTypeId })
    this.store.dispatch<any>(
      new UploadBusinessImageRequest(this.businessId, payload),
    )
  }

  public delete({ type }) {
    const imageTypeId = type.get('id')
    this.store.dispatch<any>(
      new DeleteBusinessImageRequest(this.businessId, imageTypeId),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.imageTypes$.unsubscribe()
    this.settings$.unsubscribe()
  }
}
